import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';
/**
 * lr-monitoring's Pro modal, looked up when it is clicked rather than at boot:
 * the two bundles load in whichever order the site enables the extensions.
 */
function proModal() {
  return window.flarum?.reg?.get('linkrobins-lr-monitoring', 'components/ProModal');
}

/**
 * The dashboard's two nudges, under the discussion list's own menu: the review
 * card, then Link Robins Pro once Pro is visible (the tip card before that),
 * the same pair the dashboard shows (Karl, 2026-10-06: "match dashboard").
 *
 * lr-monitoring and lr-services each carry their own copy of these as separate
 * WallNudge/TipNudge files, reaching lr-home's modals through the registry at
 * click time so nothing depends on bundle order. This copy lives IN lr-home,
 * which owns both modals, so it imports them directly — there is no other
 * bundle to be out of step with.
 *
 * Rendered as a sibling of the sidebar's <nav>, not as an item inside it: the
 * sidebar's items render into a <ul>, and these are asides, not menu entries.
 * That also matches how the dashboard's PageShell places them, which is what
 * the .LrNudge styles are written against.
 */
export default class IndexNudges extends Component {
  view() {
    const T = (section, k) => app.translator.trans(`linkrobins-lr-home.forum.${section}.${k}`);

    // Both still work without JS or if a modal fails to load: the anchor keeps
    // its href and the page it lands on offers the same thing.
    const open = modal => e => {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      app.modal.show(modal);
    };
    return [m("aside", {
      className: "LrNudge"
    }, m("p", {
      className: "LrNudge-title"
    }, m(Icon, {
      name: "fas fa-heart"
    }), " ", T('nudge', 'title')), m("p", {
      className: "LrNudge-text"
    }, T('nudge', 'text')), m("a", {
      href: app.routes['lr.wall'] ? app.route('lr.wall') : '#',
      className: "LrNudge-cta",
      onclick: open(() => import(/* webpackChunkName: 'forum/components/ReviewModal', webpackMode: 'lazy-once' */ './ReviewModal'))
    }, T('nudge', 'cta'), " \u2192")), app.forum.attribute('lrProVisible') ? this.pro(T) : m("aside", {
      className: "LrNudge LrNudge--tip"
    }, m("p", {
      className: "LrNudge-title"
    }, m(Icon, {
      name: "fas fa-mug-hot"
    }), " ", T('tip_nudge', 'title')), m("p", {
      className: "LrNudge-text"
    }, T('tip_nudge', 'text')), m("a", {
      href: app.routes['lr.tips'] ? app.route('lr.tips') : '#',
      className: "LrNudge-cta",
      onclick: open(() => import(/* webpackChunkName: 'forum/components/TipModal', webpackMode: 'lazy-once' */ './TipModal'))
    }, T('tip_nudge', 'cta'), " \u2192"))];
  }

  /**
   * Same words as the dashboard's ProNudge. Members open the Pro modal; a
   * guest has nothing to buy with yet, so they go to the pricing section.
   */
  pro(T) {
    const active = !!app.forum.attribute('lrProActive');
    const price = app.forum.attribute('lrProPrice') || 60;
    const monthly = app.forum.attribute('lrProMonthlyPrice') || 6;
    const signedIn = !!app.session.user;
    return m("aside", {
      className: "LrNudge LrNudge--pro"
    }, m("p", {
      className: "LrNudge-title"
    }, m(Icon, {
      name: "fas fa-star"
    }), " ", active ? T('pro_nudge', 'member_title') : T('pro_nudge', 'title')), m("p", {
      className: "LrNudge-text"
    }, active ? T('pro_nudge', 'member_text') : app.translator.trans('linkrobins-lr-home.forum.pro_nudge.text', {
      monthly,
      price
    })), m("a", {
      href: signedIn ? '/dashboard/pro' : '/#pricing',
      className: "LrNudge-cta",
      onclick: e => {
        const Modal = proModal();
        if (!signedIn || !Modal || e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault();
        app.modal.show(Modal);
      }
    }, active ? T('pro_nudge', 'member_cta') : T('pro_nudge', 'cta'), " \u2192"));
  }
}
flarum.reg.add('linkrobins-lr-home', 'forum/components/IndexNudges', IndexNudges);flarum.reg.addChunkModule('103', '507', 'linkrobins-lr-home', 'forum/components/ReviewModal');